import { useMemo, useState } from "react"
import { observer } from "mobx-react-lite"

import type { MinimalToken, TokenName } from "@/domains/core"
import { DialogSearch } from "@/domains/common/components/dialogues/dialog-search"
import { MinimalPoolStore } from "@/domains/minimal-pool/minimal-pool-store"
import { filterMinimalPools } from "@/domains/minimal-pool/utils/filter-minimal-pools"

import { MinimalPoolDialog } from "../minimal-pool-dialog"
import { MinimalPoolList } from "../minimal-pool-list"

export const SimpleMinimalPoolDialog: React.FC<{
  isOpen: boolean
  pools: Array<MinimalPoolStore>
  governanceToken: TokenName
  nativeToken: MinimalToken & TokenName
  wrappedNativeToken: string
  onClose: () => void
  onPoolSelect: (pool: MinimalPoolStore | null) => void
}> = observer(({ isOpen, pools, governanceToken, nativeToken, wrappedNativeToken, onClose, onPoolSelect }) => {
  const [search, setSearch] = useState("")

  // Filter pools to only those with gauges
  const poolsWithGauges = useMemo(() => {
    return pools.filter((pool) => pool.hasGauge)
  }, [pools])

  // Apply search filter
  const filteredPools = useMemo(() => {
    return poolsWithGauges.filter((pool) =>
      filterMinimalPools(pool, search, nativeToken.symbol, wrappedNativeToken),
    )
  }, [poolsWithGauges, search, nativeToken.symbol, wrappedNativeToken])

  // Sort by TVL descending
  const sortedPools = useMemo(() => {
    return [...filteredPools].sort((a, b) => b.tvlUsd - a.tvlUsd)
  }, [filteredPools])

  return (
    <MinimalPoolDialog isOpen={isOpen} onClose={onClose} minHeight={320} title="Select Pair">
      <DialogSearch
        value={search}
        onChange={setSearch}
        placeholder={`${governanceToken.name}, ${nativeToken.name}, BTC, ETH, 0x...`}
      />

      <MinimalPoolList pools={sortedPools} onPoolSelect={onPoolSelect} onClose={onClose} />
    </MinimalPoolDialog>
  )
})

